@if (icon) {
    <fui-icon class="icon" [icon]="icon.icon" [height]="icon.height || 20" [width]="icon.width || 20"
              [color]="icon.color" [clickable]="true" fui-touch (shortTouch)="selectOption()"></fui-icon>
}
<span class="option" fui-touch (shortTouch)="selectOption()">{{ label(option) }}</span>
@if (optionOpenable) {
    <fui-icon class="action" [icon]="'chevron-right'" [height]="16" [width]="16"
              [clickable]="true" (click)="openOption($event)"></fui-icon>
}
